import { render } from "./AnswerForm.vue?vue&type=template&id=fed23750&scoped=true"
import script from "./AnswerForm.vue?vue&type=script&lang=ts"
export * from "./AnswerForm.vue?vue&type=script&lang=ts"

import "./AnswerForm.vue?vue&type=style&index=0&id=fed23750&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fed23750"

export default script
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtnToggle,QBtn,QInput,QList});
